// extracted by mini-css-extract-plugin
export default {"footerLower":"Footer_footerLower__H3xFB","customerExp":"Footer_customerExp__mZKI0","copyright":"Footer_copyright__jkz+G","unstyled":"Footer_unstyled__EEPBW"};